export default "__VITE_ASSET__HYPw4F4b__"